import React from "react";
import { Privilege } from "@/api/privileges";
import { removeRolePrivileges, Role, RolePrivileges } from "@/api/roles";
import { DataGrid, DataGridColumn } from "@/ui-controls/DataGrid";
import MoreActionsButton from "@/ui-controls/MoreActionsButton";

interface Props {
  role: Role;
  privilegeList: Privilege[];
  onRemovePrivileges?: (privilegeIds: number[]) => any;
  onDelete: (privilege: Privilege) => any;
}

const AppRolePrivilegeDetailList = (props: Props) => {
  const removeRolePrivilege = (privilege: Privilege) => {
    removeRolePrivileges({
      RoleId: props.role.Id,
      PrivilegeIds: [privilege.Id],
    } as RolePrivileges).then(
      (_) => {
        if (props.onRemovePrivileges) props.onRemovePrivileges([privilege.Id]);
      },
      (error) => {
        handleError(error);
      }
    );
  };

  const handleError = (error: Error) => {
    // Error handling would go here in real app
  };

  const columns: DataGridColumn[] = [
    {
      key: "id",
      name: "Id",
      fieldName: "Id",
      minWidth: 50,
      maxWidth: 60,
      isRowHeader: true,
      isResizable: true,
      isPadded: true,
    },
    {
      key: "name",
      name: "Name",
      fieldName: "Name",
      minWidth: 150,
      maxWidth: 250,
      isRowHeader: true,
      isResizable: true,
      isPadded: true,
    },
    {
      key: "description",
      name: "Description",
      fieldName: "Description",
      minWidth: 150,
      maxWidth: 250,
      isRowHeader: true,
      isResizable: true,
      isPadded: true,
    },
    {
      key: "Actions",
      name: "",
      minWidth: 50,
      maxWidth: 70,
      onRender: (item: Privilege) => (
        <MoreActionsButton
          menu={[
            {
              key: "remove",
              text: "Remove privilege from role",
              iconProps: { iconName: "Cancel" },
              onClick: () => {
                removeRolePrivilege(item);
              },
            },
            // {
            //   key: "deactivate",
            //   text: "Deactivate customer",
            //   iconProps: { iconName: "Delete" },
            //   onClick: () => {
            //     setMenuActionType(MenuActionType.DEACTIVATE_CUSTOMER);
            //     setSelectedCustomer(item);
            //   },
            // },
            // {
            //   key: "addSection",
            //   text: "Add",
            //   iconProps: { iconName: "Add" },
            //   subMenuProps: {
            //     items: [
            //       {
            //         key: "addUser",
            //         text: "User",
            //         title: "Add application user",
            //         onClick: () => {
            //           setMenuActionType(MenuActionType.ADD_USER);
            //           setSelectedCustomer(item);
            //         },
            //       },
            //       {
            //         key: "restrictPrivileges",
            //         text: "Restrict Privileges",
            //         title: "Restrict customer privileges",
            //         onClick: () => {
            //           setMenuActionType(MenuActionType.RESTRICT_PRIVILEGES);
            //           setSelectedCustomer(item);
            //         },
            //       },
            //     ],
            //   },
            // },
          ]}
        />
      ),
    },
  ];

  return (
    <>
      <DataGrid items={props.privilegeList} columns={columns} />
    </>
  );
};

export default AppRolePrivilegeDetailList;
